import React from "react";
import { translate } from "../../Services/translation";
const { compose, withProps, withStateHandlers } = require("recompose");
const { withScriptjs, withGoogleMap, GoogleMap, Marker } = require("react-google-maps");
const { InfoBox } = require("react-google-maps/lib/components/addons/InfoBox");

const DetailedStyledMapWithAnInfoBox = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyBxYLDy8IZe-4HW-MFQJJStXFJX8i7q7cI&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `500px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withStateHandlers(() => ({
    isOpen: false,
    openInfoWindowMarkerId: "",
  })),

  withScriptjs,
  withGoogleMap
)((props) => (
  <GoogleMap defaultZoom={10} center={{ lat: parseFloat(props.selection.latitude), lng: parseFloat(props.selection.longitude) }}>
    <Marker position={{ lat: props.selection.latitude, lng: props.selection.longitude }}>
      <InfoBox options={{ closeBoxURL: ``, enableEventPropagation: true }}>
        <div className="map-address">
          <h3>{props.selection.AgentName}</h3>
          <p>{props.selection.Address}</p>
          <p>
            <a href={"mailto:" + props.selection.Email}>{props.selection.Email}</a>
          </p>
          <p>
            <a href={"tel:" + props.selection.Phone}>{props.selection.Phone}</a>
          </p>
          {props.selection.ResellerWebsiteUrl && props.selection.ResellerWebsiteUrl.length >0 && 
            <p>
              <a href={props.selection.ResellerWebsiteUrl} target="_blank">{props.selection.ResellerWebsiteUrl}</a>
            </p>
          }
        </div>
      </InfoBox>
    </Marker>
  </GoogleMap>
));

export default DetailedStyledMapWithAnInfoBox;
